export { default } from './Copy';